import ActivityCard, { Activity } from '../../components/ActivityCard'
import { FadeIn } from '../../components/AnimateIn'
import Section from '../../components/Section'
import { Text } from '../../components/Text'

const sundayActivities: Activity[] = [
  {
    title: 'Worship Meeting',
    startTime: '16:00',
    endTime: '18:00',
    dayOfWeek: 'Sunday',
    hall: 'D1, St. Luke’s Hall',
    location: 'Holy Trinity Church',
    address: 'Oud Metha, Dubai, UAE',
  },
]
const weekdayActivities: Activity[] = [
  {
    title: 'Bible Study',
    startTime: '20:30',
    endTime: '22:30',
    dayOfWeek: 'Wednesday',
    hall: 'D1, St. Luke’s Hall',
    location: 'Holy Trinity Church',
    address: 'Oud Metha, Dubai, UAE',
  },
  {
    title: 'Hindi Gospel Meeting',
    startTime: '20:30',
    endTime: '22:30',
    dayOfWeek: 'Friday',
    hall: 'Dubai Evangelical Church Centre (DECC)',
    location: 'Jebal Ali',
    address: 'Dubai, UAE',
  },
]

const weekendActivities: Activity[] = [
  {
    title: 'Sunday School',
    startTime: '18:45',
    endTime: '20:15',
    dayOfWeek: 'Saturday',
    hall: 'C1, St. Martin’s Hall',
    location: 'Holy Trinity Church',
    address: 'Oud Metha, Dubai, UAE',
  },
  {
    title: 'Gospel Meeting',
    startTime: '20:15',
    endTime: '21:30',
    dayOfWeek: 'Saturday',
    hall: 'C1, St. Martin’s Hall',
    location: 'Holy Trinity Church',
    address: 'Oud Metha, Dubai, UAE',
  },
]

export default function OurActivities() {
  return (
    <div className='bg-white'>
      <Section withVerticalPadding className='flex flex-col gap-[44px]'>
        <FadeIn>
          <Text.H2>Our Activities</Text.H2>
        </FadeIn>
        <div className='flex flex-col flex-grow-0 lg:flex-row gap-8 items-center'>
          <FadeIn delay={0.2} className='flex flex-1 w-full'>
            <ActivityCard title='Sunday' activities={sundayActivities} />
          </FadeIn>
          <FadeIn delay={0.4} className='flex flex-1 w-full'>
            <ActivityCard title='Weekday' activities={weekdayActivities} />
          </FadeIn>
          <FadeIn delay={0.6} className='flex flex-1 w-full'>
            <ActivityCard title='Weekend' activities={weekendActivities} />
          </FadeIn>
        </div>
      </Section>
    </div>
  )
}
